exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".procurement-schedules-show .capacity-notices{font-size:10pt;color:#c00}.procurement-schedules-show .capacities-panel.capacity-disabled{color:#ccc}", ""]);

// exports
